import { URLS } from 'api/constants';
import { useMutation } from 'hooks/useMutation';
import { apiRequest } from 'lib/api/client';

type DeleteFavoriteRequest = {
  favoriteId: string;
};

type AddFavoriteRequest = {
  casinoId?: string;
  streamerId?: string;
  slotId?: string;
};

export const useAddToFavoriteMutation = () =>
  useMutation<AddFavoriteRequest, void>(({ casinoId, slotId, streamerId }) =>
    apiRequest<void>(URLS.FAVORITE, {
      method: 'POST',
      auth: true,
      body: { casinoId, slotId, streamerId },
    })
  );

export const useRemoveFromFavoriteMutation = () =>
  useMutation<DeleteFavoriteRequest, void>(({ favoriteId }) =>
    apiRequest<void>(URLS.FAVORITE, {
      method: 'DELETE',
      auth: true,
      body: { favoriteId },
    })
  );
